import IntervalScale from 'echarts/lib/scale/Interval';
import ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import Radar from 'echarts/lib/coord/radar/Radar';
import type GlobalModel from 'echarts/lib/model/Global';
import { dvRadarSeriesModelClazz } from './radarSeriesModel';
import RadarModel from 'echarts/lib/coord/radar/RadarModel';
import { alignScaleTicks } from 'echarts/lib/coord/axisAlignTicks';
import * as zrUtil from 'zrender/src/core/util';
import IndicatorAxis from 'echarts/lib/coord/radar/IndicatorAxis';

type Point = number[];

export default function dvRadarLayoutFunc(ecModel: GlobalModel, api: ExtensionAPI) {
  const dvRadarSeriesModel = ecModel.getSeriesByType('dvRadar');
  const radarList: Radar[] = [];

  dvRadarSeriesModel.forEach((seriesModel: dvRadarSeriesModelClazz) => {

    ecModel.eachComponent('radar', function (radarModel: RadarModel) {
      const radar = new Radar(radarModel, ecModel, api);
      radarList.push(radar);

      if (seriesModel.get('coordinateSystem') === 'radar') {
        seriesModel.coordinateSystem = radarList[seriesModel.get('radarIndex') || 0];
      }
      const data = seriesModel.getData();
      const points: Point[][] = [];
      const coordSys = seriesModel.coordinateSystem as Radar;

      if (!coordSys) {
        return;
      }
      const axes = coordSys.getIndicatorAxes() as IndicatorAxis[];

      zrUtil.each(axes, function (axis, axisIndex) {
        let indicatorAxis = coordSys._indicatorAxes[axisIndex];

        // 设置数据的最大值最小值，以便后续点坐标计算
        const min = indicatorAxis.model.option.min;
        const max = indicatorAxis.model.option.max;
        indicatorAxis.scale.setExtent(min,max)

        data.each(data.mapDimension(axis.dim), function (val: number, dataIndex) {
          points[dataIndex] = points[dataIndex] || [];

          // 通过值和所在轴计算位置，并按照顺时针排列
          let coord = axis.dataToCoord(val);
          let angle = indicatorAxis.angle;
          let x;
          if (!seriesModel.option.dvClockWise) {
            x = coordSys.cx + coord * Math.cos(angle);
          } else {
            x = coordSys.cx - coord * Math.cos(angle);
          }
          let y = coordSys.cy - coord * Math.sin(angle);
          const point = [x, y];

          coordSys.coordToPoint(indicatorAxis.dataToCoord(val), axisIndex);

          points[dataIndex][axisIndex] = isValidPoint(point)
            ? point
            : getValueMissingPoint(coordSys);
          data.setItemLayout(dataIndex, points[dataIndex]);
          const splitNumber = radarModel.get('splitNumber');
          const dummyScale = new IntervalScale();
          dummyScale.setExtent(0, splitNumber);
          dummyScale.setInterval(1);

          alignScaleTicks(indicatorAxis.scale as IntervalScale, indicatorAxis.model, dummyScale);
        });
      });
    });
  });
}

function isValidPoint(point: Point) {
  return !isNaN(point[0]) && !isNaN(point[1]);
}

function getValueMissingPoint(coordSys: Radar): Point {
  // It is error-prone to input [NaN, NaN] into polygon, polygon.
  // (probably cause problem when refreshing or animating)
  return [coordSys.cx, coordSys.cy];
}
